var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSkipPrevious = function SvgSkipPrevious(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17V7q0-.424.287-.713A.97.97 0 0 1 6.5 6q.424 0 .713.287.287.288.287.713v10q0 .424-.287.712A.97.97 0 0 1 6.5 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5.5 17m11.45-.025-6.2-4.15a1 1 0 0 1-.338-.362A1 1 0 0 1 10.3 12q0-.25.112-.463a1 1 0 0 1 .338-.362l6.2-4.15a.6.6 0 0 1 .275-.125q.15-.025.275-.025.4 0 .7.275t.3.725v8.25q0 .45-.3.725t-.7.275a2 2 0 0 1-.275-.025.6.6 0 0 1-.275-.125"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSkipPrevious);
export { ForwardRef as ReactComponent };